var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVoltar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1309",
    d: "M34.9,18.9c-1.9-6-7.8-10.2-15-10.3V1.6c0-0.3-0.3-0.6-0.6-0.6c-0.1,0-0.3,0-0.4,0.1L0.8,14.2 c-0.3,0.2-0.3,0.6-0.1,0.8c0,0,0,0,0,0l0.1,0.1l18.1,13.1c0.3,0.2,0.6,0.1,0.9-0.1c0.1-0.1,0.1-0.2,0.1-0.4v-7 c4.4,0,8.1,2.1,9.4,5.2c1.1,2.7,0.2,5.6-2.4,8c-0.2,0.2-0.3,0.6-0.1,0.8c0,0,0,0,0,0c0.1,0.1,0.3,0.2,0.4,0.2h0.5 c0.1,0,0.2,0,0.3-0.1C34.1,31,36.7,24.8,34.9,18.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVoltar01);
export default __webpack_public_path__ + "static/media/ico-voltar-01.fb656c934070e0156ea5b1d941feed20.svg";
export { ForwardRef as ReactComponent };